import { useTranslation } from 'react-i18next';
import { FileCheck, Users, BarChart3 } from 'lucide-react';
import { Section, Container } from '../../ui';
import { IllustrationCompliance } from '../../icons';
import styles from './Compliance.module.css';

const featureIcons = [FileCheck, Users, BarChart3];

export function Compliance() {
  const { t } = useTranslation('home');

  const blocks = t('compliance.blocks', { returnObjects: true }) as {
    title: string; text: string;
  }[];

  return (
    <Section variant="light">
      <Container>
        <div className={styles.splitGrid}>
          <div className={styles.illustrationCol}>
            <IllustrationCompliance className={styles.illustration} />
          </div>

          <div className={styles.contentCol}>
            <span className={styles.badge}>{t('compliance.badge')}</span>
            <h2 className={styles.heading}>{t('compliance.sectionTitle')}</h2>
            <p className={styles.subtitle}>{t('compliance.intro')}</p>

            <div className={styles.features}>
              {blocks.map((block, i) => {
                const Icon = featureIcons[i];
                return (
                  <div key={i} className={styles.featureItem}>
                    <div className={styles.featureIcon}>
                      <Icon size={20} strokeWidth={1.5} />
                    </div>
                    <div>
                      <h3 className={styles.featureTitle}>{block.title}</h3>
                      <p className={styles.featureTagline}>{block.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <p className={styles.hook}>{t('compliance.hook')}</p>
          </div>
        </div>
      </Container>
    </Section>
  );
}
